import dispatcher from '../others/Dispatcher';

export function updateTickets(tickets) {
    dispatcher.dispatch({
        type: 'UPDATE_QA_TICKETS',
        body: tickets
    });
}

export function updateFilter(filter) {
    dispatcher.dispatch({
        type: 'UPDATE_QA_FILTER',
        body: filter
    });
}

export function updateSort(sort) {
    dispatcher.dispatch({
        type: 'UPDATE_QA_SORT',
        body: sort
    });
}

export function updateMeta(meta) {
    dispatcher.dispatch({
        type: 'UPDATE_QA_META',
        body: meta
    });
}


// WEBPACK FOOTER //
// ./src/js/actions/QAActions.js